import { render } from "./EditAutoInvestment.vue?vue&type=template&id=0594e0c7"
import script from "./EditAutoInvestment.vue?vue&type=script&lang=js"
export * from "./EditAutoInvestment.vue?vue&type=script&lang=js"

import "./EditAutoInvestment.vue?vue&type=style&index=0&id=0594e0c7&lang=css"

import exportComponent from "/usr/src/app/vue-goparity/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__